/* eslint-disable @nx/enforce-module-boundaries */
import { useCmsConfig } from '@cms/config'
import { useCrmConfig } from '@crm/config'
import { useInsuranceConfig } from '@insurance/config'
import { AppConfig, AppNames } from '@shared/types'

const useDefaultMenu = () => {
  return {
    key: AppNames.Default,
    path: '/',
    menu: []
  }
}

export const configMap: Record<AppNames, () => AppConfig> = {
  [AppNames.Cms]: useCmsConfig,
  [AppNames.Default]: useDefaultMenu,
  [AppNames.Insurance]: useInsuranceConfig,
  [AppNames.Crm]: useCrmConfig
}
